import { render, staticRenderFns } from "./membershipProgramDetail.vue?vue&type=template&id=535964eb&scoped=true&"
import script from "./membershipProgramDetail.vue?vue&type=script&lang=js&"
export * from "./membershipProgramDetail.vue?vue&type=script&lang=js&"
import style0 from "./membershipProgramDetail.vue?vue&type=style&index=0&id=535964eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535964eb",
  null
  
)

export default component.exports